import { computed } from 'vue';

export function useSearchEngine() {
    const searchEngineMenuItems = computed(() => ({
        list: [
            {
                id: '__search_engine',
                label: 'Search engine',
                items: [
                    {
                        icon: 'search',
                        label: 'Search engine dashboard',
                        id: 'searchEngineDashboard.index',
                    },
                ],
            },
        ],
    }));

    return { searchEngineMenuItems };
}
